module.exports = __webpack_public_path__ + "media/icons/up-arrow-a16b7c1c.png";